const cities = [
  { name: "Cocoa Beach", zips: "32931, 32932" },
  { name: "Cape Canaveral", zips: "32920" },
  { name: "Merritt Island", zips: "32952, 32953" },
  { name: "Port Canaveral", zips: "32920" },
  { name: "Rockledge", zips: "32955" },
  { name: "Satellite Beach", zips: "32937" },
  { name: "Indian Harbour Beach", zips: "32937" },
  { name: "Viera", zips: "32940, 32955" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or the beach in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function CocoaBeachLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Cocoa Beach &amp; the Northern Space Coast
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Cocoa Beach, Cape Canaveral, Merritt Island, or anywhere along the northern Space Coast, Fast Passport Center makes expedited passport processing simple — no drive to Miami, no agency lines, no guessing.
          </p>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Cocoa Beach occupies a special place on Florida's Space Coast — a barrier island community that blends surf culture, space exploration, and beachside living into a lifestyle found nowhere else in America. With approximately 11,500 year-round residents swelling to many times that number during peak tourist seasons, Cocoa Beach is both a tight-knit coastal town and one of the most famous beach destinations on the Atlantic coast. The city stretches along six miles of Atlantic shoreline, anchored by the historic Cocoa Beach Pier — a landmark that has drawn surfers, families, sunbathers, and spring breakers for generations — and bordered by the Banana River to the west, creating a waterfront community on both sides.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            What defines Cocoa Beach more than anything is its relationship with the space program. The city sits directly south of Cape Canaveral Space Force Station and the Kennedy Space Center, and for decades Cocoa Beach was the off-duty playground for astronauts, engineers, and mission control personnel. During the Apollo era, Cocoa Beach was known as the place where astronauts lived, surfed, and unwound between missions. That legacy endures today — you can still watch rocket launches from the beach, the pier, or any waterfront bar and restaurant along A1A. SpaceX Falcon 9 and Falcon Heavy launches are a regular occurrence, drawing launch chasers from around the world to Cocoa Beach's shoreline.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The surfing culture of Cocoa Beach is legendary. Home to Kelly Slater, the greatest competitive surfer in history, and the Ron Jon Surf Shop — the world's largest surf shop and a destination in its own right — Cocoa Beach is the East Coast's surfing capital. The consistent Atlantic swells draw surfers year-round, and the local surf community travels internationally to Costa Rica, Nicaragua, Puerto Rico, and Indonesia for swell seasons and competitions. These surf trips are often booked on short notice when a storm forms and the swell forecast solidifies, creating a recurring pattern of passport urgency.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Port Canaveral, the busiest cruise port in the world, sits just a few miles north of Cocoa Beach along the coast. Disney Cruise Line, Royal Caribbean, Carnival, Norwegian, and MSC all operate extensive Caribbean and Bahamas itineraries from Port Canaveral. For Cocoa Beach residents, a cruise is not a distant vacation — it's a weekend trip. The proximity to the port means locals book cruises with minimal lead time, and many discover expired passports only when receiving their boarding documents days before sailing. Every passenger needs a valid passport for most itineraries, and cruise lines will deny boarding without exception for expired or near-expired documents.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            The geographic reality of Cocoa Beach matters for passport processing. The closest regional passport agency is in Miami, approximately 180 miles south via I-95 — a drive that consumes three to four hours. For a Cocoa Beach surfer heading to Costa Rica for an approaching swell, a family with a Disney cruise departing from Port Canaveral in three days, or a launch photographer chasing a Falcon Heavy night launch in French Guiana, that drive is not practical. Fast Passport Center's courier-based expedited service means you start online from your Cocoa Beach condo or Cape Canaveral home — and your passport arrives within days, not months.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Cocoa Beach — approximately 160 miles south via I-95
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Brevard County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Brevard County — start online, ship overnight, and we handle the rest. No need to drive to Miami.
              </p>
            </div>

            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Melbourne", href: "/melbourne" },
                  { name: "Titusville", href: "/titusville" },
                  { name: "Orlando", href: "/orlando" },
                  { name: "Daytona Beach", href: "/daytona-beach" },
                  { name: "Port St. Lucie", href: "/port-st-lucie" },
                  { name: "Stuart", href: "/stuart" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}